import { staticUrls } from '@/shared/config';

const DESCRIPTION_BOTTOM_SHEET = 'flight-delay-description-bottom-sheet';
export const CONDITIONS_BOTTOM_SHEET = 'flight-delay-conditions-bottom-sheet';
export const FLIGHT_DELAY_FORM_BOTTOM_SHEET = 'flight-delay-form-bottom-sheet';
export const FLIGHT_DELAY_SUCCESS_MODAL = 'flight-delay-success-modal';
export const RULES_FILE_LINK =
  'https://front.ffins.kz/report/DxXKSbImHcPhfMqr/ru?_gl=1*tyknpn*_gcl_au*MjA0MTI1NjAyMy4xNzczODMxMDIw';
export const PAYOUT_REQUEST_LINK = staticUrls.flightDelayPayoutRequestDoc;
export const FORM_REQUEST_LINK = staticUrls.flightDelayFormRequestDoc;

export const flightDelayConfig = {
  DESCRIPTION_BOTTOM_SHEET,
  CONDITIONS_BOTTOM_SHEET,
  FLIGHT_DELAY_FORM_BOTTOM_SHEET,
  FLIGHT_DELAY_SUCCESS_MODAL,
  RULES_FILE_LINK,
  PAYOUT_REQUEST_LINK,
  FORM_REQUEST_LINK,
};
